import { render, staticRenderFns } from "./AdmissionProcessResult.vue?vue&type=template&id=512da547"
import script from "./AdmissionProcessResult.vue?vue&type=script&lang=js"
export * from "./AdmissionProcessResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports